<div class="overlay" *ngIf="isLoading$ | async"> 
    <div class="loadingio-spinner-dual-ring-9ii3dfl9cqn"><div class="ldio-hxt977ialef">
        <div></div><div><div></div></div>
        </div></div>
</div>
